var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list-item",
    [
      _c("w-list-item-text", [_vm._v(_vm._s(_vm.doc.getName()))]),
      _c(
        "w-list-item-action",
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("open-document"),
                  expression: "$ct('open-document')",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.open()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "eye" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-list-item-action",
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("download-document"),
                  expression: "$ct('download-document')",
                },
              ],
              attrs: { disabled: _vm.downloading },
              on: {
                click: function ($event) {
                  return _vm.download()
                },
              },
            },
            [
              _c("w-fa", {
                attrs: { icon: _vm.downloadIcon, spin: _vm.downloading },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.edit
        ? _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("delete-document"),
                      expression: "$ct('delete-document')",
                    },
                  ],
                  staticClass: "danger",
                  attrs: { disabled: _vm.uploading },
                  on: {
                    click: function ($event) {
                      return _vm.deleteDocument()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }